import config from "../../src/common/default_config";

let SSOCookieOptions = {
  path: "",
  domain: "newspaperscotland.uat-dlv.sandbox-mailplus.gcpp.io",
};

const homeRedirectionLinkUAT =
  "https://uat-dlv.sandbox-mailplus.gcpp.io/newspaper-scotland";

const homeRedirectionLinkPROD = "https://www.mailplus.co.uk/newspaper-scotland";

const homeRedirectionLink =
  process.env.ENV === "uat" || process.env.ENV === "dev"
    ? homeRedirectionLinkUAT
    : homeRedirectionLinkPROD;

if (process.env.ENV === "production") {
  SSOCookieOptions = {
    path: "",
    domain: "newspaperscotland.mailplus.co.uk",
  };
}

export default class options extends config {
  static editor = "The Mail Scotland";

  // Kiosk options

  // ER options
  static product_name_for_engage_readers = "Daily";

  // SSO options
  static SSOEnabled = true;
  static getSSOTokenFromUrl = true;
  static urlSSOTokenParameter = "token";
  static paywallRedirectionUrl = true;
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "OPENID",
  };
  static SSOCookieOptions = SSOCookieOptions;
  static SSOCookieName = "oa-token";

  // default pdf rendering settings
  static page_ratio = 1.4925;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static extraLinkDirectAccess = true;

  static touchDownloadPdf = true;
  static printCroppedPdf = true;
  static shareFromReader = true;
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    GooglePlus: false,
    Twitter: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "The Mail Scotland - ",
  };
  static socialSharingHash = "social";
  static homeRedirectionLink = homeRedirectionLink;
  static homeRedirectionLinkUAT = homeRedirectionLinkUAT;
  static homeRedirectionLinkPROD = homeRedirectionLinkPROD;

  static enrichment_placement_vertical = "bottom";
  static enrichment_placement_horizontal = "right";
}



// WEBPACK FOOTER //
// ./clients/dmg-sco/config.js